import { FormControl } from "@mui/material";
import { FieldProps } from "@rjsf/core";
import { CardSimple } from "components/card";

export const CardSimpleForm = (props: FieldProps<string>) => {


    return (
        <FormControl component="fieldset" className="control-card-simple">
            <CardSimple
                label={props.schema.title}
                description={props.formData}
                />
        </FormControl>
        
    )
}
